import React from 'react';
import { useLocale } from '../i18n/LocaleContext';
import { analytics, WebAnalyticsEvent } from '../analytics/analyticsService';
import { APP_STORE_URL, googlePlayUrl } from '../constants/storeLinks';
import appStoreBadge from '../assets/images/appStore.svg';
import googlePlayBadge from '../assets/images/googlePlay.svg';

type Props = {
  /** Height of each badge box in px. Width is derived to keep both badges identical. */
  height?: number;
  /**
   * Event being shared, when the badges are shown from an event context.
   * Rides to Google Play as an install referrer so the app can open that event
   * after the install (deferred deep link). No iOS equivalent exists.
   */
  eventId?: string | null;
  className?: string;
  style?: React.CSSProperties;
};

export const StoreBadges = ({ height = 56, eventId, className, style }: Props): React.JSX.Element => {
  const { t } = useLocale();
  const cls = ['store-badges', className].filter(Boolean).join(' ');
  const playUrl = googlePlayUrl(eventId);

  return (
    <div className={cls} style={style}>
      <div className="store-badges__row">
        <a
          className="store-badge"
          href={APP_STORE_URL}
          aria-label={`${t('store.apple.top')} ${t('store.apple.main')}`}
          onClick={() =>
            analytics.logEvent(WebAnalyticsEvent.STORE_CLICK, {
              store: 'ios',
              ...(eventId ? { event_id: eventId } : {}),
            })
          }
        >
          <img src={appStoreBadge} alt={`${t('store.apple.top')} ${t('store.apple.main')}`} style={{ height }} />
        </a>
        <a
          className="store-badge"
          href={playUrl}
          aria-label={`${t('store.google.top')} ${t('store.google.main')}`}
          onClick={() =>
            analytics.logEvent(WebAnalyticsEvent.STORE_CLICK, {
              store: 'android',
              ...(eventId ? { event_id: eventId } : {}),
            })
          }
        >
          <img src={googlePlayBadge} alt={`${t('store.google.top')} ${t('store.google.main')}`} style={{ height }} />
        </a>
      </div>
    </div>
  );
};
